import AnimatedComponent from './AnimatedComponent';
import { TranslateDirection } from './constants';
export default AnimatedComponent;
export { TranslateDirection };
